import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { mapPartnerProduct } from '../../services/partner.service';
import { fetchProductDropdownList } from '../../services/product.service';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';
import WithLogin from '../withLogin.component';
import AddProduct from '../product/productAdd.component';

const MapPartnerProduct = props => {
    const [show, setModalShow] = useState(props.open);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [productList, setProductList] = useState([]);
    const [openProductAddForm, setProductOpenAddForm] = useState(false);

    const handleModalClose = () => {
        setModalShow(false);
        props.setOpenAddForm(false);
        props.reloadDataTable();
    };

    const getProductList = async () => {
        setLoading(true);
        try {
            const products = await fetchProductDropdownList();
            setProductList(products);
            setValue('product_id', products[0].id);
        } catch (error) {
            setMessage({
                detail: 'An error has occurrded during product list loading.',
                type: 'Error',
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        getProductList();
        setModalShow(props.open);
        setMessage({});
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    const {
        register,
        reset,
        handleSubmit,
        setError,
        setValue,
    } = useForm({
        defaultValues: {
            product_id: '',
        },
    });

    const handleMapPartnerProdut = async data => {
        setLoading(true);
        try {
            setMessage({});
            const partnerProductData = {
                "partner_id": props.partnerId,
                "product_id": data.product_id
            }
            await mapPartnerProduct(partnerProductData);
            setMessage({
                type: 'Success',
                message: 'Partner has been mapped with product successfully',
            });
            reset();
        } catch (error) {
            if (error.response.status === 400) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
                error.response.data.errors?.forEach(validationError => {
                    Object.keys(validationError).forEach(key => {
                        setError(key, { message: validationError[key] });
                    });
                });
            }
        }

        setLoading(false);
    };

    const handleProductOpenAddForm = () => {
        setProductOpenAddForm(true);
    };

    return (
        <AppModal
            size="lg"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="Map Product">
            {openProductAddForm && (
                <AddProduct
                    open={openProductAddForm}
                    setOpenAddForm={setProductOpenAddForm}
                    reloadDataTable={getProductList}
                />
            )}
            {!openProductAddForm &&
                <div className="formView">
                    <form
                        className="row g-2"
                        onSubmit={handleSubmit(handleMapPartnerProdut)}>
                        {message && message.type && (
                            <MessageContainer message={message} />
                        )}
                        <div className="row">
                            <div className="col-md-8">
                                <label htmlFor="Product">Product</label>
                                <select
                                    className="form-control"
                                    id="Product"
                                    {...register('product_id', {})}>
                                    {productList.map(product => (
                                        <option value={product.id} key={product.id}>
                                            {product.name} (
                                            {
                                                product.extra_attributes[
                                                'units_per_box'
                                                ]
                                            }{' '}
                                            device
                                            {product.extra_attributes[
                                                'units_per_box'
                                            ] === 1
                                                ? ''
                                                : 's'}
                                            {product.extra_attributes[
                                                'units_per_box'
                                            ] === 1
                                                ? ''
                                                : ' / box'}
                                            )
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label>&nbsp;</label>
                                <span id="header-add-btn">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleProductOpenAddForm}
                                    >
                                        + Add new product
                                    </button>
                                </span>

                            </div>
                        </div>
                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}>
                                {loading && (
                                    <span className="spinner-border spinner-border-sm"></span>
                                )}
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            }
        </AppModal>
    );
};

export default WithLogin(MapPartnerProduct);
